import {ChangeDetectionStrategy, Component, input, ViewEncapsulation} from "@angular/core";
import {DonationProgressBarDummyComponent} from "../dummy/donation-progress-bar.dummy.component";
import {DonationStateDummyComponent} from "../dummy/donation-state.dummy,component";

@Component({
  standalone: true,
  selector: 'app-donation-progress-bar-and-state-combining',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [
    DonationProgressBarDummyComponent,
    DonationStateDummyComponent,
  ],
  template: `

    <app-donation-progress-bar-dummy
      [goalAmount]="goalAmount()"
      [totalRaised]="totalRaised()"/>

    <app-donation-state-component
      [currency]="currency()"
      [goalAmount]="goalAmount()"
      [totalRaised]="totalRaised()"
      [donations]="donations()"/>
  `,
  host: {
    class: 'w-full'
  }
})
export class DonationProgressBarAndStateCombiningComponent {

  public readonly currency = input<string>('EUR');
  public readonly totalRaised = input<number>(0);
  public readonly goalAmount = input<number>(0);
  public readonly donations = input<number>(0);

}
